import { useEffect, useState } from 'react';

/**
 * Parent-controlled (via Settings): allow the Explore search feature on this device.
 * Stored in localStorage. Default true.
 */
const STORAGE_KEY = 'explore-search-feature-enabled-v1';

const listeners = new Set();

function emit() {
  listeners.forEach((fn) => fn());
}

/** @returns {boolean} */
export function loadSearchFeatureEnabled() {
  if (typeof window === 'undefined') return true;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (raw === null) return true;
    return raw === '1' || raw === 'true';
  } catch {
    return true;
  }
}

/** @param {boolean} enabled */
export function setSearchFeatureEnabled(enabled) {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(STORAGE_KEY, enabled ? '1' : '0');
  } catch {
    /* quota / private mode */
  }
  emit();
}

/** @param {() => void} cb @returns {() => void} */
export function subscribeSearchFeatureEnabled(cb) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

/**
 * @returns {[boolean, (enabled: boolean) => void]}
 */
export function useSearchFeatureEnabled() {
  const [enabled, setEnabled] = useState(() => loadSearchFeatureEnabled());
  useEffect(() => subscribeSearchFeatureEnabled(() => setEnabled(loadSearchFeatureEnabled())), []);
  return [enabled, setSearchFeatureEnabled];
}
